/**
 * Marks a string to be parsed by the i18next parser (at scripts/i18next-parser.config.js) to create i18n.json files
 * Use it for static object or when you want to store a key for translation (instead of translated value).  The result is the same key, and it can be used with getTranslation() or t() to retrieve the localized string.
 *
 * @param key in the i18n.json files
 * @returns the same string that was provided
 */
export const asTranslationKey = (key: string) => key
